import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import {
  FamilyStatusBadge,
  HelpLink
} from '../../../../../../components/generic'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'
import { Button, Icon } from '@lmc/ui-kit'

const formatName = (carer) => {
  if (carer && carer.name) return `• ${carer.name.first} ${carer.name.last}`
  return ''
}

export default function ProfileFamilyInviteField({
  buttonGlyph = 'MailOutlined',
  openModal,
  contact,
  familySetupComplete,
  resendInvite,
  residentName,
  carer,
  label
}) {
  const [isLoading, setIsLoading] = useState(false)
  const comment = contact.familyComment
  const commentDate = dayjs(contact.familyCommentDate).format(
    'DD-MM-YYYY • HH:mm'
  )

  const renderResendInviteButton = () => (
    <Button
      disabled={isLoading || !contact.familyHasAccess || !contact.email}
      onClick={() => {
        setIsLoading(true)
        resendInvite(contact.familyAccountId, () => setIsLoading(false))
      }}
    >
      <Icon name={buttonGlyph} />
      {isLoading ? 'Loading...' : 'Resend invite'}
    </Button>
  )

  const renderInviteButton = (familyHasAccess) => {
    if (familyHasAccess !== false) {
      return (
        <Button disabled={!contact.email} onClick={openModal} variant="default">
          <Icon name={buttonGlyph} />
          Create invite
        </Button>
      )
    }
  }

  const renderBody = () => (
    <div>
      <FamilyStatusBadge contact={contact} residentName={residentName} />
      {comment && (
        <div style={styles.commentContainer}>
          <div style={styles.commentDateContainer}>
            {`${commentDate} ${formatName(carer)}`}
          </div>
          {comment}
        </div>
      )}
      <div style={styles.buttonContainer}>
        {/* {!contact.email && <span style={styles.errorText}>{MISSING_EMAIL_TEXT}</span> } */}
        {contact.familyAccountId
          ? renderResendInviteButton()
          : renderInviteButton(contact.familyHasAccess)}
        {!contact.email && !comment && (
          <span style={styles.errorText}>{MISSING_EMAIL_TEXT}</span>
        )}
        <div style={styles.helpContainer}>
          <HelpLink supportLink={HELP_ARTICLE_URL} />
        </div>
      </div>
    </div>
  )

  const renderPaywallLink = () => (
    <div>
      <p>
        Set up the Family App <Link to={`/settings/familySettings`}>here</Link>{' '}
        to start inviting family members.
      </p>
      <HelpLink supportLink={HELP_ARTICLE_URL} />
    </div>
  )

  return (
    <div style={styles.wrapper}>
      <div style={styles.label}>{label}</div>
      {familySetupComplete ? renderBody() : renderPaywallLink()}
    </div>
  )
}

const MISSING_EMAIL_TEXT = 'Add an email address to create invite'
const HELP_ARTICLE_URL =
  'https://support.logmycare.co.uk/en/articles/4107695-what-is-the-family-app'

const styles = {
  badgeContainer: {
    display: 'flex',
    marginBottom: 10
  },
  buttonContainer: {
    marginTop: 10,
    marginBottom: 10
  },
  commentContainer: {
    color: colors.black,
    marginBottom: 10
  },
  commentDateContainer: {
    color: colors.darkgrey,
    fontSize: 12,
    marginTop: 5
  },
  errorText: {
    color: colors.pink,
    paddingLeft: 15,
    position: 'relative',
    top: 2
  },
  helpContainer: {
    marginTop: 13
  },
  label: {
    fontSize: 12,
    fontWeight: 'bold'
  },
  wrapper: {
    borderBottom: '1px solid',
    borderColor: colors.grey,
    padding: '6px 0px',
    position: 'relative'
  }
}

ProfileFamilyInviteField.propTypes = {
  carer: PropTypes.object,
  contact: PropTypes.object,
  familySetupComplete: PropTypes.bool,
  label: PropTypes.string,
  resendInvite: PropTypes.func
}
